import { Theme } from './constants';

export const whenTheme = (
  theme: Theme | null | undefined,
  lightOptionValue: () => any,
  darkOptionValue: () => any,
) => (theme === Theme.light ? lightOptionValue() : darkOptionValue());
